import React from "react";
import { Helmet } from "react-helmet-async";
import BlogList from "../Components/Blog/BlogList/BlogList";
import { useSiteSeo } from "../context/SiteSeoContext";
import { usePageSeo } from "../hooks/usePageSeo";
import { useManagedPageContent } from "../hooks/useManagedPageContent";
import BlockRenderer from "../Components/BlockRenderer/BlockRenderer";

const Blog = () => {
  const siteCtx = useSiteSeo();
  const { seo_title, seo_description, og_image_url, robots } = usePageSeo('blog');
  const { blocks } = useManagedPageContent('blog');

  const siteName = siteCtx.site_name || siteCtx.organization_name || 'Gem Fashion Studios';
  const title = seo_title || `Fashion Blog — Styling Tips & Trends | ${siteName}`;
  const description = seo_description || `Explore our fashion blog for styling inspiration, outfit ideas, festival looks, and tips on rental fashion.`;
  const ogImage = og_image_url || siteCtx.default_og_image_url || '';

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="robots" content={robots || 'index,follow'} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        {ogImage && <meta property="og:image" content={ogImage} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
      </Helmet>
      {blocks && <BlockRenderer content={blocks} />}
      <BlogList />
    </>
  );
};

export default Blog;
